<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/contact-icon.svg" alt="Contactos" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Contactos</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{selectedItem === 'recientes' ? 'Contactos de hoy' : 'Todos los contactos'}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todos los contactos
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Contactos de hoy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline" (click)="openMdlCreateContact()">
                            <img class="color-org" src="assets/svg/plus-orange.svg" alt="Añadir nuevo" width="16" height="16" />
                            Nuevo Contacto
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{contactosFiltrados.length}} elementos | Se actualizó hace 2 minutos</span>
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>

                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="!isLoading && contactos.length > 0">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar por nombre, cuenta, teléfono o correo..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarContacts()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>

                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th 
                                            (click)="sortByColumn('nombre')"
                                            [class.sorted]="sortColumn === 'nombre'"
                                            class="sortable-header"
                                        >
                                            Nombre Completo
                                            <span *ngIf="sortColumn === 'nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('cuenta.nombre_empresa')"
                                            [class.sorted]="sortColumn === 'cuenta.nombre_empresa'"
                                            class="sortable-header"
                                        >
                                            Nombre de la cuenta
                                            <span *ngIf="sortColumn === 'cuenta.nombre_empresa'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('telefono')"
                                            [class.sorted]="sortColumn === 'telefono'"
                                            class="sortable-header"
                                        >
                                            Teléfono
                                            <span *ngIf="sortColumn === 'telefono'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('email')"
                                            [class.sorted]="sortColumn === 'email'"
                                            class="sortable-header"
                                        >
                                            Correo
                                            <span *ngIf="sortColumn === 'email'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('ejecutivo.nombre')"
                                            [class.sorted]="sortColumn === 'ejecutivo.nombre'"
                                            class="sortable-header"
                                        >
                                            Propietario del contacto
                                            <span *ngIf="sortColumn === 'cuenta.ejecutivo.nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let contacto of contactosFiltrados; let i=index" [class.contacto-invalido]="!contacto.contacto_id" (click)="verDetalleContacto(contacto.contacto_id, $event)">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td>{{contacto.nombre.charAt(0).toUpperCase() + contacto.nombre.slice(1) + ' ' + contacto.apellido.charAt(0).toUpperCase() + contacto.apellido.slice(1)}}</td>
                                        <td>{{contacto.cuenta.nombre_empresa.charAt(0).toUpperCase() + contacto.cuenta.nombre_empresa.slice(1)}}</td>
                                         <td>{{ '+569' + ' ' + contacto.telefono }}</td>
                                        <td>{{contacto.email}}</td>
                                        <td>{{ contacto.ejecutivo?.nombre}} {{contacto.ejecutivo?.apellido}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + contacto.contacto_id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + contacto.contacto_id">
                                                    <button class="dropdown-item" (click)="updateContact(contacto)">Modificar</button>
                                                    <button class="dropdown-item" (click)="openMdlDeleteContact(contacto.contacto_id)">Eliminar</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="!isLoading && contactos.length === 0 && !errorMessage" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                <img src="assets/img/listaprospecto.png" alt="Lista de contactos vacía" />
                            </div>
                            <h2>Sin Contactos por ahora</h2>
                            <p>Todavía no tienes Contactos registrados. Puedes comenzar agregando uno nuevo.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>